import { render, staticRenderFns } from "./switch-control.vue?vue&type=template&id=45adc537"
import script from "./switch-control.vue?vue&type=script&lang=js"
export * from "./switch-control.vue?vue&type=script&lang=js"
import style0 from "./switch-control.vue?vue&type=style&index=0&id=45adc537&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/apps/wpms/web/wind-plannerDev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45adc537')) {
      api.createRecord('45adc537', component.options)
    } else {
      api.reload('45adc537', component.options)
    }
    module.hot.accept("./switch-control.vue?vue&type=template&id=45adc537", function () {
      api.rerender('45adc537', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/leaflet-map/switch-control.vue"
export default component.exports